import sr_RS from '../../date-picker/locale/sr_RS'
export default sr_RS



// WEBPACK FOOTER //
// ./components/calendar/locale/sr_RS.js